import { CORAL_800, WHITE } from 'constants/styling/theme'

import { ComposerAttachments } from '../helpers/useChatAttachments'
import { FC } from 'react'
import { PendingAttachmentChip } from './PendingAttachmentChip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { rejectionMessage } from '../helpers/chatAttachments'
import { useTranslation } from 'react-i18next'

interface Props {
  attachments: ComposerAttachments
  disabled?: boolean
}

export const AttachmentTray: FC<Props> = ({ attachments, disabled = false }) => {
  const { t } = useTranslation(['chat'])
  const { items, rejections, onRemove, onRetry } = attachments

  return (
    <>
      {(rejections.length > 0 || items.length > 0) &&
        <Stack gap="0.8rem" sx={{ padding: '1.2rem 1.6rem 0', backgroundColor: WHITE }}>

          {rejections.length > 0 &&
            <Stack role="alert" gap="0.2rem">
              {rejections.map((rejection, index) => {
                const { key, values } = rejectionMessage(rejection)
                return (
                  <Typography key={`${rejection.reason}-${index}`} variant="text-xs" sx={{ color: CORAL_800 }}>
                    {t(key, values)}
                  </Typography>
                )
              })}
            </Stack>
          }

          {items.length > 0 &&
            <Stack direction="row" flexWrap="wrap" gap="0.8rem" sx={{ maxHeight: '14rem', overflowY: 'auto' }}>
              {items.map((item) => (
                <PendingAttachmentChip
                  key={item.key}
                  attachment={item}
                  disabled={disabled}
                  onRemove={onRemove}
                  onRetry={onRetry}
                />
              ))}
            </Stack>
          }

        </Stack>
      }
    </>
  )
}
